'use strict';

(function () {

  const ENH_I18N = {
    es: {
      fav_filter: 'FAVORITOS',
      fav_save: 'GUARDAR',
      fav_saved: 'GUARDADO',
      res_piece: 'pieza', res_pieces: 'piezas',
      res_fav: 'favorito', res_favs: 'favoritos',
      res_suffix: 'en el drop',
      no_matches: 'SIN FAVORITOS',
      see_all: 'VER TODO EL DROP',
      zoom_hint: 'CLIC = PANTALLA COMPLETA',
      zoom_hint_touch: 'DESLIZA PARA CAMBIAR · TOCA = PANTALLA COMPLETA',
      toast_add: '\u2665 AÑADIDO A FAVORITOS',
      toast_remove: 'RETIRADO DE FAVORITOS',
      toast_none: 'AÚN NO TIENES FAVORITOS · PULSA \u2665 EN UNA PIEZA'
    },
    en: {
      fav_filter: 'FAVORITES',
      fav_save: 'SAVE',
      fav_saved: 'SAVED',
      res_piece: 'piece', res_pieces: 'pieces',
      res_fav: 'favorite', res_favs: 'favorites',
      res_suffix: 'in the drop',
      no_matches: 'NO FAVORITES',
      see_all: 'SEE THE WHOLE DROP',
      zoom_hint: 'CLICK = FULLSCREEN',
      zoom_hint_touch: 'SWIPE TO BROWSE · TAP = FULLSCREEN',
      toast_add: '\u2665 ADDED TO FAVORITES',
      toast_remove: 'REMOVED FROM FAVORITES',
      toast_none: 'NO FAVORITES YET · TAP \u2665 ON A PIECE'
    },
    fr: {
      fav_filter: 'FAVORIS',
      fav_save: 'ENREGISTRER',
      fav_saved: 'ENREGISTRÉ',
      res_piece: 'pièce', res_pieces: 'pièces',
      res_fav: 'favori', res_favs: 'favoris',
      res_suffix: 'dans le drop',
      no_matches: 'AUCUN FAVORI',
      see_all: 'VOIR TOUT LE DROP',
      zoom_hint: 'CLIC = PLEIN ÉCRAN',
      zoom_hint_touch: 'GLISSEZ POUR CHANGER · TOUCHEZ = PLEIN ÉCRAN',
      toast_add: '\u2665 AJOUTÉ AUX FAVORIS',
      toast_remove: 'RETIRÉ DES FAVORIS',
      toast_none: 'PAS ENCORE DE FAVORIS · APPUYEZ SUR \u2665'
    }
  };

  function hasI47P() {
    return typeof window !== 'undefined'
      && window.I47P
      && typeof window.I47P.registerI18n === 'function';
  }

  function currentLang() {
    if (hasI47P()) return window.I47P.getLang();
    const l = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
    return ENH_I18N[l] ? l : 'es';
  }

  function T(key) {
    if (hasI47P()) {
      const v = window.I47P.t(key);
      if (v !== undefined) return v;
    }
    return (ENH_I18N[currentLang()] || ENH_I18N.es)[key];
  }

  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const REDUCE_MOTION = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s).replace(/[&<>"]/g, c =>
    ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]));

  const FAV_KEY = '47p_favorites';
  function getFavs() {
    try {
      const parsed = JSON.parse(localStorage.getItem(FAV_KEY));
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (v) { return typeof v === 'string'; });
    } catch { return []; }
  }
  function setFavs(a) {
    try {
      const clean = Array.isArray(a) ? a.filter(function (v) { return typeof v === 'string'; }) : [];
      localStorage.setItem(FAV_KEY, JSON.stringify(clean));
    } catch (e) {}
  }
  function toggleFav(id) {
    id = String(id);
    const f = getFavs();
    const i = f.indexOf(id);
    if (i === -1) f.push(id); else f.splice(i, 1);
    setFavs(f);
    return f.indexOf(id) !== -1;
  }

  let toastTimer = null;
  function toast(msg) {
    const t = $('#enh-toast');
    if (!t) return;
    t.innerHTML = '<span class="toast__mark">//</span>' + esc(msg);
    t.classList.add('is-shown');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-shown'), 1900);
  }

  function updateFavUI() {
    const favs = getFavs();
    const n = favs.length;

    const navBadge = $('#nav-fav-badge');
    if (navBadge) {
      navBadge.textContent = n;
      navBadge.classList.toggle('is-shown', n > 0);
    }
    const navFav = $('#nav-fav');
    if (navFav) navFav.classList.toggle('is-on', n > 0);

    const ctrlCount = $('#fav-filter-count');
    if (ctrlCount) ctrlCount.textContent = n;

    $$('.fav-btn').forEach(btn => {
      const on = favs.indexOf(String(btn.dataset.favId)) !== -1;
      btn.classList.toggle('is-fav', on);
      btn.setAttribute('aria-pressed', on);
    });

    const pBtn = $('#product-fav-btn');
    if (pBtn) {
      const on = favs.indexOf(String(pBtn.dataset.favId)) !== -1;
      pBtn.classList.toggle('is-fav', on);
      pBtn.setAttribute('aria-pressed', on);
      const lbl = $('#product-fav-label');
      if (lbl) lbl.textContent = on ? T('fav_saved') : T('fav_save');
    }
  }

  function popFav(btn) {
    if (REDUCE_MOTION || !btn) return;
    btn.classList.remove('pop'); void btn.offsetWidth; btn.classList.add('pop');
  }
  function burstHearts(btn) {
    if (REDUCE_MOTION || !btn) return;
    const host = btn.closest('.img-container') || btn.parentElement;
    if (!host) return;
    const r = btn.getBoundingClientRect();
    const hr = host.getBoundingClientRect();
    for (let i = 0; i < 5; i++) {
      const s = document.createElement('span');
      s.className = 'fav-burst';
      s.textContent = '\u2665';
      s.style.left = (r.left - hr.left + 12) + 'px';
      s.style.top = (r.top - hr.top + 8) + 'px';
      s.style.setProperty('--bx', (Math.random() * 60 - 30) + 'px');
      s.style.setProperty('--by', (-30 - Math.random() * 40) + 'px');
      host.appendChild(s);
      setTimeout(() => s.remove(), 700);
    }
  }
  function handleFavToggle(id, btn) {
    const nowFav = toggleFav(id);
    if (nowFav) {
      popFav(btn); burstHearts(btn);
      const nb = $('#nav-fav-badge');
      if (nb && !REDUCE_MOTION) { nb.classList.remove('pop'); void nb.offsetWidth; nb.classList.add('pop'); }
      toast(T('toast_add'));
    } else {
      toast(T('toast_remove'));
    }
    updateFavUI();
    if (favOnly) applyFilter();
  }

  let favOnly = false;

  function applyFilter() {
    const grid = $('#product-grid');
    if (!grid) return;
    const favs = getFavs();
    let shown = 0;

    $$('.product-card', grid).forEach(card => {
      const id = String(card.dataset.favId || '');
      const show = !favOnly || favs.indexOf(id) !== -1;
      card.classList.toggle('is-filtered', !show);
      if (show) shown++;
    });

    const empty = $('#archive-empty');
    if (empty) empty.classList.toggle('is-shown', favOnly && shown === 0);

    const cnt = $('#result-count');
    if (cnt) cnt.textContent = shown;
    const label = $('#result-label');
    if (label) {
      const word = favOnly ? (shown === 1 ? T('res_fav') : T('res_favs'))
                           : (shown === 1 ? T('res_piece') : T('res_pieces'));
      label.textContent = word + ' ' + T('res_suffix');
    }
  }

  function applyEnhI18n() {
    const ff = $('#fav-filter-label');
    if (ff) ff.textContent = T('fav_filter');
    const zh = $('#zoom-hint-text');
    if (zh) {
      const touchUI = window.matchMedia && window.matchMedia('(hover: none)').matches;
      zh.textContent = T(touchUI ? 'zoom_hint_touch' : 'zoom_hint');
    }
    const big = $('#archive-empty-big');
    if (big) big.textContent = T('no_matches');
    const reset = $('#archive-reset');
    if (reset) reset.textContent = T('see_all');
    applyFilter();
    updateFavUI();
  }

  function enableFavView(scroll) {
    favOnly = true;
    const ff = $('#fav-filter');
    if (ff) { ff.classList.add('is-active'); ff.setAttribute('aria-pressed', 'true'); }
    applyFilter();
    if (scroll) {
      const a = $('#archive-anchor') || $('.archive-controls');
      if (a) window.scrollTo({ top: a.offsetTop - 80, behavior: REDUCE_MOTION ? 'auto' : 'smooth' });
    }
    if (getFavs().length === 0) toast(T('toast_none'));
  }

  function initIndex() {
    const grid = $('#product-grid');
    if (!grid) return;

    const favFilter = $('#fav-filter');
    if (favFilter) favFilter.addEventListener('click', () => {
      favOnly = !favOnly;
      favFilter.classList.toggle('is-active', favOnly);
      favFilter.setAttribute('aria-pressed', favOnly);
      applyFilter();
      if (favOnly && getFavs().length === 0) toast(T('toast_none'));
    });

    const reset = $('#archive-reset');
    if (reset) reset.addEventListener('click', () => {
      favOnly = false;
      if (favFilter) { favFilter.classList.remove('is-active'); favFilter.setAttribute('aria-pressed', 'false'); }
      applyFilter();
    });

    if (location.hash === '#favorites') {
      requestAnimationFrame(() => enableFavView(true));
    }

    applyFilter();
  }

  function initNavFav() {
    const navFav = $('#nav-fav');
    if (!navFav) return;
    navFav.addEventListener('click', e => {
      if ($('#product-grid')) {
        e.preventDefault();
        enableFavView(true);
      }
    });
  }

  function initFavButtons() {
    document.addEventListener('click', e => {
      const fb = e.target.closest('.fav-btn, #product-fav-btn');
      if (!fb) return;
      e.preventDefault();
      e.stopPropagation();
      handleFavToggle(fb.dataset.favId, fb);
    });
  }

  function initGalleryLightbox() {
    const wrap = $('#gallery-main-wrap');
    if (!wrap) return;
    wrap.addEventListener('click', () => openLightbox());
  }

  let lb = { imgs: [], idx: 0, built: false };
  let lbLastFocused = null;

  function galleryImages() {
    const thumbs = $$('.product-gallery__thumb[data-img-src]');
    let imgs = thumbs.map(t => t.dataset.imgSrc).filter(Boolean);
    const main = $('#product-main-image');
    if (!imgs.length && main) imgs = [main.getAttribute('src')];
    return imgs;
  }

  function buildLightbox() {
    const el = document.createElement('div');
    el.className = 'lightbox';
    el.id = 'lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.innerHTML =
      '<div class="lightbox__topbar">' +
        '<span class="lightbox__label"><span class="lightbox__label-bar"></span><span id="lb-label">47PRIVATE</span></span>' +
        '<button class="lightbox__close" id="lb-close" aria-label="Cerrar" type="button">&times;</button>' +
      '</div>' +
      '<div class="lightbox__stage" id="lb-stage">' +
        '<button class="lightbox__nav lightbox__nav--prev" id="lb-prev" aria-label="Anterior" type="button">&#8249;</button>' +
        '<img class="lightbox__img" id="lb-img" alt="" draggable="false">' +
        '<button class="lightbox__nav lightbox__nav--next" id="lb-next" aria-label="Siguiente" type="button">&#8250;</button>' +
      '</div>' +
      '<div class="lightbox__thumbs" id="lb-thumbs" role="list"></div>';
    document.body.appendChild(el);

    $('#lb-close').addEventListener('click', closeLightbox);
    el.addEventListener('click', e => { if (e.target === el) closeLightbox(); });
    $('#lb-prev').addEventListener('click', () => lbGo(-1));
    $('#lb-next').addEventListener('click', () => lbGo(1));

    el.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      const focusables = $$('button', el).filter(b => !b.disabled && b.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    const stage = $('#lb-stage');

    let lbStartX = 0;
    let lbStartY = 0;
    let lbTracking = false;
    stage.addEventListener('touchstart', e => {
      if (e.touches.length !== 1) { lbTracking = false; return; }
      lbTracking = true;
      lbStartX = e.touches[0].clientX;
      lbStartY = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', e => {
      if (!lbTracking) return;
      lbTracking = false;
      const t = e.changedTouches[0];
      const dx = t.clientX - lbStartX;
      const dy = t.clientY - lbStartY;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) lbGo(dx < 0 ? 1 : -1);
    }, { passive: true });
    stage.addEventListener('touchcancel', () => { lbTracking = false; }, { passive: true });

    lb.built = true;
  }

  function renderLbThumbs() {
    const wrap = $('#lb-thumbs');
    wrap.innerHTML = lb.imgs.map((src, i) =>
      '<button class="lightbox__thumb ' + (i === lb.idx ? 'is-active' : '') + '" data-i="' + i + '" type="button"><img src="' + esc(src) + '" alt=""></button>'
    ).join('');
    $$('.lightbox__thumb', wrap).forEach(t => t.addEventListener('click', () => lbSet(+t.dataset.i)));
    wrap.style.display = lb.imgs.length > 1 ? 'flex' : 'none';
  }
  function lbSet(i) {
    lb.idx = (i + lb.imgs.length) % lb.imgs.length;
    const img = $('#lb-img');
    img.src = lb.imgs[lb.idx];
    $$('#lb-thumbs .lightbox__thumb').forEach((t, k) => t.classList.toggle('is-active', k === lb.idx));
  }
  function lbGo(d) { lbSet(lb.idx + d); }

  function openLightbox() {
    if (!lb.built) buildLightbox();
    lb.imgs = galleryImages();
    if (!lb.imgs.length) return;
    let start = 0;
    const strip = $('#gallery-strip');
    if (strip && strip.clientWidth > 0) {
      start = Math.round(strip.scrollLeft / strip.clientWidth);
    }
    if (start < 0 || start >= lb.imgs.length) start = 0;
    lb.idx = start;
    const labelEl = $('#lb-label');
    const meta = document.querySelector('[data-product-label]');
    if (labelEl) labelEl.textContent = meta ? meta.getAttribute('data-product-label') : '47PRIVATE';
    renderLbThumbs();
    lbSet(lb.idx);
    $('#lightbox').classList.add('is-open');
    document.body.style.overflow = 'hidden';
    lbLastFocused = document.activeElement;
    const closeBtn = $('#lb-close');
    if (closeBtn) closeBtn.focus();
  }
  function closeLightbox() {
    const el = $('#lightbox');
    if (!el) return;
    el.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lbLastFocused && typeof lbLastFocused.focus === 'function') lbLastFocused.focus();
    lbLastFocused = null;
  }
  document.addEventListener('keydown', e => {
    const el = $('#lightbox');
    if (el && el.classList.contains('is-open')) {
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') lbGo(-1);
      else if (e.key === 'ArrowRight') lbGo(1);
    }
  });

  function init() {
    const eventName = (hasI47P() && window.I47P.EVENT_LANGCHANGE) || 'i47p:langchange';
    document.addEventListener(eventName, applyEnhI18n);

    updateFavUI();
    initIndex();
    initNavFav();
    initFavButtons();
    initGalleryLightbox();

    if (hasI47P()) {
      window.I47P.registerI18n(ENH_I18N);
    } else {
      applyEnhI18n();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }

})();